import type { ApiErrors } from 'shared/api'

const GOOGLE_CALENDAR_ERROR_KEYS: string[] = [
  'settings.google_calendar.value',
  'settings.google_calendar.account_id',
  'settings.booking_availability.value',
  'settings.booking_availability.timezone',
  'settings.booking_durations.value',
]

export const hasGoogleCalendarErrors = (errors: ApiErrors) =>
  errors.keys().some((key) => GOOGLE_CALENDAR_ERROR_KEYS.includes(key))
